module.exports = __webpack_public_path__ + "assets/img/login.e79aab9b.png";